<div class="footer-wrapper">
  <div class="container block">
    <h2>uPoints Leaderboard</h2>
    <p>Here are the testers who have earned the most uPoints <a uiSref="gamification">(click here to see how)</a>. These are great people to follow and connect with.</p>

    <ut-tabs [activeTabId]="activeTab" (tabChange)="onTabChange($event)">
      <ut-tab tabId="recent" label="Last 30 Days">
        @for (leader of recent.feedItems; track leader) {
          <ut-feed-leaderboard class="feed leaderboard" [user]="leader"></ut-feed-leaderboard>
        }
        <ut-load-more (loadMore)="recent.loadMore()" [isLoading]="recent.isLoading" [isLastPage]="recent.isLastPage"></ut-load-more>
      </ut-tab>

      <ut-tab tabId="allTime" label="All Time">
        @for (leader of allTime.feedItems; track leader) {
          <ut-feed-leaderboard class="feed leaderboard" [user]="leader"></ut-feed-leaderboard>
        }
        <ut-load-more (loadMore)="allTime.loadMore()" [isLoading]="allTime.isLoading" [isLastPage]="allTime.isLastPage"></ut-load-more>
      </ut-tab>
    </ut-tabs>
  </div>
</div>
